import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';
import { useLocale } from 'src/locales';

// ----------------------------------------------------------------------

export const navData = [
  { title: 'Home', path: '/' },
  { title: 'Business_Solutions', path: paths.forBusiness },
  { title: 'About_Us', path: paths.about },
  { title: 'Contact_Us', path: paths.contactUs },
  { title: 'Careers', path: paths.careers },
];
